import { __awaiter } from "tslib";
import apis from '@/requests';
export const Options = {
    body: {
        key: [],
        name: [],
        show: [],
        baseLine: []
    },
    refs: {
        tags: '[tag]',
        events: '[event]',
        breeds: '[breed]'
    },
    loaders: {
        fetch(self, done, fail, { type }) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    let data = yield apis.crop.get(type);
                    if (data) {
                        self.$init(data);
                    }
                    done(self);
                }
                catch (error) {
                    fail(error);
                }
            });
        }
    },
    list: {
        key: model => model.key,
        methods: {
            getBreed(self, type, breed) {
                return self.fetch(type).breeds.fetch(breed);
            }
        },
        loaders: {
            fetch(self, done, fail) {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        let result = yield apis.crop.list();
                        self.batchWrite(result);
                        done(self);
                    }
                    catch (error) {
                        fail(error);
                    }
                });
            }
        }
    }
};
